export default __webpack_public_path__ + "static/media/gallery-wip-emitter_00.08a512e8.jpg";